export const OPTIMIZATION_TYPES = {
    OVERSIZED: 'oversized',
    UNDERSIZED: 'undersized',
    OSM: 'osm',
    SQLM: 'sqlm',
};

export const REQUIRED_OPTIONS = [OPTIMIZATION_TYPES.UNDERSIZED, OPTIMIZATION_TYPES.OVERSIZED];

export const MODERNIZATION_OPTIONS = [OPTIMIZATION_TYPES.OSM, OPTIMIZATION_TYPES.SQLM];

export const DEFAULT_NEW_DISK_SIZE_GB = 90;
export const MAX_SOCKETS_CORES = 72;
export const MAX_MEMORY_GB = 128;
